import { render, staticRenderFns } from "./cModalServicioProvider.vue?vue&type=template&id=94563882"
import script from "./cModalServicioProvider.vue?vue&type=script&lang=js"
export * from "./cModalServicioProvider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports